/* global Linear */
import merge from 'lodash/merge';
import clone from 'lodash/clone';
import fluxDefaults from './defaults';

// function degToRad2 ( degrees ) {
//     // Math.PI / 360 = 0.008726646259971648
//     return degrees * 0.008726646259971648;
// }
//
// function radToDeg2 (radians) {
//     // 360 / Math.PI = 114.59155902616465
//     return radians * 114.59155902616465;
// }
//
// function drawCircle(opts) {
//     const precision = opts.precision || 20;
//     const items = [];
//
//     // const width = Math.abs(opts.endWidthPct - opts.startWidthPct);
//
//     const lineWidth = Math.abs(opts.endWidthPct - opts.startWidthPct) / precision;
//     const lineHeight = Math.abs(opts.endHeightPct - opts.startHeightPct) / precision;
//     const angleSize = (Math.PI * 2) / precision;
//
//     for (let x = 0; x < precision; x += 1) {
//
//         // const x = Math.sqrt( Math.pow(x, 2) + Math.pow(opts.radius, 2) );
//         const y = Math.sqrt(Math.pow(x, 2) + Math.pow(opts.radius, 2));
//
//         const xx = opts.endWidthPct > opts.startWidthPct ?
//             opts.startWidthPct + (lineWidth * x) : opts.startWidthPct - (lineWidth * x);
//
//         const yy = opts.endHeightPct > opts.startHeightPct ?
//             opts.startHeightPct + (lineHeight * y) : opts.startHeightPct - (lineHeight * y);
//
//         items.push(
//             {
//                 width: lineWidth,
//                 height: opts.lineHeight,
//                 x: `${xx}%`,
//                 y: `${yy}%`,
//                 angle: `${radToDeg2(angleSize) * x}`,
//             },
//         );
//     }
//
//     return items;
// }

const width = 50;
const height = 75;
const xtario = 5;
const yratio = 2;
const gapHeight = 70;

const centerWidth = 8;
const centerHeight = 6;

// const circle = drawCircle({
//     lineHeight: 10,
//     startWidthPct: 50,
//     endWidthPct: 80,
//     startHeightPct: 60,
//     endHeightPct: 30,
//     minAngle: Math.PI,
//     maxAngle: Math.PI * 2,
//     angle: 'rad',
//     radius: 5,
// });

module.exports = merge(clone(fluxDefaults, true), {
    // particleScale: 0.6,
    // particlesRadius: 0.07,
    // particlesDampingStrength: 0.5,
    gravity: 1,
    initialTicks: 100,
    walls: [
        // left
        {
            width: 20,
            height: '100%',
            x: '-100%',
            y: '0%',
        },
        {
            width: 20,
            height: '27%',
            x: '0%',
            y: '48%',
        },
        {
            width: 20,
            height: '27%',
            x: '0%',
            y: '5%',
        },
        // top
        {
            width: '300%',
            height: 10,
            x: '-100%',
            y: `${height - gapHeight}%`,
        },
        // bottom
        {
            width: '300%',
            height: 10,
            x: '-100%',
            y: `${height}%`,
        },
        // right
        {
            width: 20,
            height: '100%',
            x: '200%',
            y: '0%',
        },
        {
            width: 20,
            height: '27%',
            x: '98%',
            y: '48%',
        },
        {
            width: 20,
            height: '27%',
            x: '98%',
            y: '5%',
        },

        // bottom right 1
        // {
        //     width: '20%',
        //     height: 10,
        //     x: `${width}%`,
        //     y: `${height - 2}%`,
        //     angle: -15,
        // },
        // // bottom right 2
        // {
        //     width: '20%',
        //     height: 10,
        //     x: '55%',
        //     y: `${height - 4}%`,
        //     angle: -30,
        // },
        // // bottom right 3
        // {
        //     width: '20%',
        //     height: 10,
        //     x: '65%',
        //     y: `${height - 6}%`,
        //     angle: -45,
        // },
        // {
        //     width: '20%',
        //     height: 10,
        //     x: '75%',
        //     y: `${height - 8}%`,
        //     angle: -60,
        // },
        // {
        //     width: '20%',
        //     height: 10,
        //     x: '85%',
        //     y: `${height - 12}%`,
        //     angle: -50,
        // },
        // bottom right 4
        // {
        //     width: '40%',
        //     height: 20,
        //     x: '73%',
        //     y: `${height - 12}%`,
        //     angle: -60,
        // },
        // bottom right 5
        // {
        //     width: '40%',
        //     height: 20,
        //     x: '73%',
        //     y: `${height - 16}%`,
        //     angle: -80,
        // },
        // top right 1
        // {
        //     width: '20%',
        //     height: 10,
        //     x: '44%',
        //     y: `${height - gapHeight + 0}%`,
        //     angle: 10,
        // },
        // // top right 2
        // {
        //     width: '20%',
        //     height: 10,
        //     x: '55%',
        //     y: `${height - gapHeight + 4}%`,
        //     angle: 20,
        // },
        // // top right 3
        // {
        //     width: '20%',
        //     height: 10,
        //     x: '65%',
        //     y: `${height - gapHeight + 8}%`,
        //     angle: 40,
        // },

        // Top left 1
        // {
        //     width: '20%',
        //     height: 10,
        //     x: '44%',
        //     y: `${height - gapHeight + 0}%`,
        //     angle: 10,
        // },
        // // top right 2
        // {
        //     width: '20%',
        //     height: 10,
        //     x: '55%',
        //     y: `${height - gapHeight + 4}%`,
        //     angle: 20,
        // },
        // // top right 3
        // {
        //     width: '20%',
        //     height: 10,
        //     x: '65%',
        //     y: `${height - gapHeight + 8}%`,
        //     angle: 40,
        // },

        // center
        {
            width: `${centerWidth}%`,
            height: '16%',
            x: '50%',
            y: '33%',
            angle: 0,
        },

        {
            width: `${centerWidth}%`,
            height: '12%',
            x: `${50 - centerWidth}%`,
            y: '35%',
            angle: 0,
        },

        {
            width: `${centerWidth}%`,
            height: '12%',
            x: `${50 + centerWidth}%`,
            y: '35%',
            angle: 0,
        },

        {
            width: `${centerWidth}%`,
            height: '8%',
            x: `${50 - (centerWidth * 1.5)}%`,
            y: '37%',
            angle: 0,
        },

        {
            width: `${centerWidth}%`,
            height: '8%',
            x: `${50 + (centerWidth * 1.5)}%`,
            y: '37%',
            angle: 0,
        },

        {
            width: `${centerWidth}%`,
            height: '4%',
            x: `${50 - (centerWidth * 2)}%`,
            y: '39%',
            angle: 0,
        },
        {
            width: `${centerWidth}%`,
            height: '4%',
            x: `${50 + (centerWidth * 2)}%`,
            y: '39%',
            angle: 0,
        },

        // Corners top
        {
            width: 20,
            height: '25%',
            x: '12%',
            y: '0%',
            angle: 45,
        },
        {
            width: 20,
            height: '25%',
            x: '86%',
            y: '0%',
            angle: 135,
        },
        // Corders bottom
        {
            width: 20,
            height: '25%',
            x: '12%',
            y: '54%',
            angle: -45,
        },
        {
            width: 20,
            height: '25%',
            x: '86%',
            y: '54%',
            angle: -135,
        },


        // Extra corners top left
        {
            width: 20,
            height: '15%',
            x: '5%',
            y: '12%',
            angle: 30,
        },
        {
            width: 20,
            height: '15%',
            x: '24%',
            y: '0%',
            angle: 60,
        },

        // Extra corners top right
        {
            width: 20,
            height: '15%',
            x: '95%',
            y: '12%',
            angle: -30,
        },
        {
            width: 20,
            height: '15%',
            x: '76%',
            y: '0%',
            angle: -60,
        },

        // Extra corners bottom right
        {
            width: 20,
            height: '15%',
            x: '95%',
            y: '52%',
            angle: 30,
        },
        {
            width: 20,
            height: '15%',
            x: '76%',
            y: '65%',
            angle: 60,
        },

        // Extra corners bottom left
        {
            width: 20,
            height: '15%',
            x: '5%',
            y: '52%',
            angle: -30,
        },
        {
            width: 20,
            height: '15%',
            x: '24%',
            y: '65%',
            angle: -60,
        },

    ],
    movingWalls: [
        // bottom left
        {
            width: 20,
            height: '20%',
            x: '-100%',
            y: '32%',
            angle: -20,
            tween: {
                x: '0%',
                duration: 2,
                repeat: -1,
                ease: Linear.easeNone,
            },
        },
        {
            width: 20,
            height: '20%',
            x: '200%',
            y: '32%',
            angle: 20,
            tween: {
                x: '90%',
                duration: 2,
                repeat: -1,
                delay: 1,
                ease: Linear.easeNone,
            },
        },

        {
            width: 10,
            height: '25%',
            x: '0%',
            y: '6%',
            angle: 20,
            tween: {
                x: '100%',
                duration: 2,
                repeat: -1,
                ease: Linear.easeNone,
            },
        },
        {
            width: 10,
            height: '25%',
            x: '100%',
            y: '52%',
            angle: 20,
            tween: {
                x: '0%',
                duration: 2,
                repeat: -1,
                delay: 1,
                ease: Linear.easeNone,
            },
        },
        // {
        //     width: 20,
        //     height: '20%',
        //     x: '50%',
        //     y: '30%',
        //     angle: 0,
        //     tween: {
        //         rotation: 360,
        //         duration: 1,
        //         repeat: -1,
        //         ease: Linear.easeNone,
        //     },
        // },
    ],
    blobs: [
        {
            x: '-98%',
            y: '22%',
            width: '100%',
            height: '40%',
            color: [0, 0, 0, 255],
        },
        {
            x: '100%',
            y: '22%',
            width: '100%',
            height: '40%',
            color: [0, 0, 0, 255],
        },
        {
            x: '20%',
            y: '22%',
            width: '10%',
            height: '40%',
            color: [255, 0, 0, 255],
        },
        {
            x: '30%',
            y: '22%',
            width: '10%',
            height: '40%',
            color: [0, 255, 0, 255],
        },
        {
            x: '50%',
            y: '22%',
            width: '20%',
            height: '40%',
            color: [0, 0, 255, 255],
        },
    ],
});



// WEBPACK FOOTER //
// ./js/flux/circleOfLife.js